// config.js (Firebase v9 modular version)
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDgnrTVGxcuLr2azFy42D1d1Sz1cZk0D1Q",
  authDomain: "faryeildfi.firebaseapp.com",
  databaseURL: "https://faryeildfi-default-rtdb.firebaseio.com",
  projectId: "faryeildfi",
  storageBucket: "faryeildfi.appspot.com",
  messagingSenderId: "989252849395",
  appId: "1:989252849395:web:76cc0864707405eff6f186"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Export the needed services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };

